import React, { useCallback, useState } from 'react';

import { AnsweringServiceSettingsContainer } from '../../answering/listing_settings';

type AnsweringServiceSettingsProps = {
  useAppointmentDeskInitial: boolean | undefined;
  toggleUseAppointmentDesk: () => void;
  answeringServicePhone: string;
};

export const AnsweringServiceSettings = ({
  useAppointmentDeskInitial,
  toggleUseAppointmentDesk,
  answeringServicePhone,
}: AnsweringServiceSettingsProps) => {
  // IMPORTANT: for listing.useAppointmentDesk field, null/undefined === true
  const [useAppointmentDesk, setUseAppointmentDesk] = useState<boolean>(
    Boolean(useAppointmentDeskInitial !== false),
  );

  const fetchSettings = useCallback(async () => ({ useAppointmentDesk, answeringServicePhone }), [useAppointmentDesk, answeringServicePhone]);

  const updateSettings = useCallback(
    (value: { useAppointmentDesk: boolean }) => {
      toggleUseAppointmentDesk();
      setUseAppointmentDesk(value.useAppointmentDesk);
    },
    [setUseAppointmentDesk, toggleUseAppointmentDesk],
  );

  return (
    <AnsweringServiceSettingsContainer
      fetchSettings={fetchSettings}
      updateSettings={updateSettings}
    />
  );
};
